// src/components/common/Footer.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as QuanteraLogo } from "../../assets/logo/quanteralogo.svg";
// import { ReactComponent as QuanteraLogoIcon } from "../../assets/logo/quanteralogoicon.svg"; // không dùng
import Map from "../../assets/icon/MapPin.svg";
import Phone from "../../assets/icon/Phone.svg";
import Mail from "../../assets/icon/EnvelopeSimple.svg";
import ISMS from "../../assets/icon/ISMS.png";
import Lock from "../../assets/icon/Lock.png";
// import CertificatePDF from "../../assets/file/Certificate ISO 2700-2022_Mobile ID_20241209.pdf"; // không cần nếu HTML tĩnh tự nhúng

export default function Footer() {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();

  const goTo = (id, after = () => { }) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    after();
  };

  const lang2 = i18n.language?.toLowerCase().startsWith("vi") ? "vi" : "en";
  const certUrl = `/${lang2}/Certificate_ISO_27001-2022.html`;
  const policyUrl = `/${lang2}/Quantera-privacy-policy-and-handling-of-personal-data.pdf`;
  const termsUrl = `/${lang2}/Quantera-terms-of-service.pdf`;
  const blogsUrl =
    lang2 === "vi"
      ? "https://quantera.vn/blogs/"
      : "https://quantera.vn/blogs/en/";
  const linkClassName = `
    relative pb-[4px] text-neutral-1
    after:content-[''] after:absolute after:left-0 after:bottom-0
    after:h-[2px] after:w-full
    after:bg-gradient-to-r after:from-[#036AE5] after:to-[#58F8FF]
    after:opacity-0
    after:transition-opacity after:duration-500 after:ease-in-out
    hover:text-white hover:after:opacity-100 hover:after:shadow-[0_-4px_8px_#2A85E9]
  `;

  return (
    <footer className="bg-neutral-13 text-neutral-3">
      <div className="max-w-[1400px] mx-auto py-10 mobile:px-10 tabletpro:px-10 tabletair:px-10 tabletmini:px-10">
        {/* Top grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-40">
          <div className="flex flex-col gap-3 mobile:gap-[26px]">
            <div className="flex items-center">
              <a
                href="/"
                title={t("common.pageTitle")}
                aria-label={t("common.pageTitle")}
              >
                <QuanteraLogo className="w-[192px] h-[50px] block" />
              </a>
            </div>

            <p className="leading-7 font-normal text-neutral-1 text-[16px] mobile:text-[14px]">
              {t("footer.explore.title", {
                defaultValue:
                  "Khám phá Quantera — nền tảng Blockchain cấp doanh nghiệp đạt chuẩn quốc tế, tích hợp toàn diện định danh số tự chủ, chứng thư số điện tử, chữ ký số tin cậy cao và ví định danh số trong một giải pháp toàn diện.",
              })}
            </p>
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-[26px]">
            <h3 className="text-neutral-1 text-[20px] mobile:text-[16px] font-semibold ">
              {t("footer.contact.contact", { defaultValue: "Liên hệ" })}
            </h3>

            <div className="flex items-start gap-3">
              <img src={Map} alt="Địa chỉ" />
              <address className="not-italic mobile:text-[14px] font-normal leading-6">
                {t("footer.contact.address", {
                  defaultValue:
                    "Tầng 9, Tòa nhà Văn Phòng Thủy Lợi 4, Số 286-288 Nguyễn Xí, Phường Bình Lợi, Quận Bình Thạnh, TP. Hồ Chí Minh",
                })}
              </address>
            </div>

            <div className="flex items-start gap-3">
              <img src={Phone} alt="Điện thoại" />
              <div className="leading-6">
                <a
                  href="tel:19006884"
                  className="mobile:text-[14px] font-normal hover:text-white"
                >
                  1900 6884
                </a>
                <br />
                <a
                  href="tel:+842836222982"
                  className="font-normal mobile:text-[14px] hover:text-white"
                >
                  +84 28 3622 2982
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <img src={Mail} alt="Email" />
              <a
                href="mailto:info@quantera.vn"
                className="leading-6 mobile:text-[14px] font-normal hover:text-white"
              >
                info@quantera.vn
              </a>
            </div>
          </div>

          {/* Abouts */}
          <div className="flex flex-col gap-[26px]">
            <h3 className="text-neutral-1 text-[20px] mobile:text-[16px] font-semibold">
              {t("footer.about.aboutquantera", { defaultValue: "Về Quantera" })}
            </h3>

            <ul className="flex flex-col mobile:text-[14px] font-normal gap-[10px]">
              {[
                {
                  key: "about",
                  label: t("footer.about.about", { defaultValue: "Giới thiệu" }),
                },
                {
                  key: "solutions",
                  label: t("footer.about.solutions", { defaultValue: "Giải pháp" }),
                },
                {
                  key: "apps",
                  label: t("footer.about.applications", { defaultValue: "Ứng dụng" }),
                },
                {
                  key: "ecosystem",
                  label: t("footer.about.ecosystem", { defaultValue: "Hệ sinh thái" }),
                },
                {
                  key: "partners",
                  label: t("footer.about.partners", { defaultValue: "Hợp tác" }),
                },
                {
                  key: "blogs",
                  href: blogsUrl,
                  label: t("footer.about.blogs", { defaultValue: "Blogs" }),
                },
                {
                  key: "contact", // sửa từ "contacts" -> "contact"
                  label: t("footer.about.contact", { defaultValue: "Liên hệ" }),
                },
              ].map(({ key, label, href }) => (
                <li key={key}>
                  {href ? (
                    <a
                      href={href}
                      className={linkClassName}
                    >
                      {label}
                    </a>
                  ) : (
                    <button onClick={() => goTo(key)} className={linkClassName}>
                      {label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Certificates */}
          {/* <div className="flex flex-col gap-[26px]">
            <h3 className="text-neutral-1 text-[20px] mobile:text-[16px] font-semibold">
              {t("footer.certificate.certificate", { defaultValue: "Chứng nhận" })}
            </h3>
            <div className="flex items-center gap-8">
              <a href={certUrl} target="_blank" rel="noopener noreferrer">
                <img src={ISMS} alt="ISO 27001" className="h-16 w-16 rounded-full" />
              </a>

              <div className="rounded-full p-2 bg-white ">
                <img src={Lock} alt="MOID Badge" className="h-12 w-12" />
              </div>
            </div>
          </div> */}
        </div>

        {/* Divider */}
        <div className="mt-8 border-t-[1px] border-[#A1A1A1]" />

        {/* Bottom bar */}
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between font-normal text-[16px] mobile:text-[14px] pt-10">
          <div className="flex gap-1 text-neutral-1">
            <p>
              {t("footer.copy", {
                year,
                defaultValue: `Copyright © 2025 - ${year} `,
              })}
            </p>

            <a
              href="/"
              title={t("common.pageTitle")}
              aria-label={t("common.pageTitle")}
            >
              Quantera
            </a>
          </div>

          <div className="flex mobile:flex-col mobile:items-start items-center gap-6 font-normal text-[16px] mobile:text-[14px] mobile:mt-4">
            <a
              href={policyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              {t("footer.links.privacy", { defaultValue: "Chính sách bảo mật" })}
            </a>
            <a
              href={termsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              {t("footer.links.terms", { defaultValue: "Điều khoản sử dụng" })}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
